export default __webpack_public_path__ + "static/logo-complet-black-text-163ba53f27940a3897f459dbf27ff435.png";